export default __webpack_public_path__ + "static/media/Media.ec24306f.png";